__turbopack_context__.v({
  "loadingSpinnerSmall": "ProfileTotals-module__VjqteG__loadingSpinnerSmall",
  "profileTotalsContainer": "ProfileTotals-module__VjqteG__profileTotalsContainer",
  "spinner": "ProfileTotals-module__VjqteG__spinner",
  "statCard": "ProfileTotals-module__VjqteG__statCard",
  "statTitle": "ProfileTotals-module__VjqteG__statTitle",
  "statValue": "ProfileTotals-module__VjqteG__statValue",
});
